module.exports = __webpack_public_path__ + "img/expand_more.bb80e324.svg";